const Results = () => {
    return (
        <>
            <p className='Help__Subtitle'>Ver resultado</p>
            <img src='/img/support/help/ztudent/results/1.png' className='Help__Image' />
            <p>¿Cómo funciona la opción <span className='Help__Text--Highlight'>Ver resultado</span>?</p>
            <p>Permite consultar los resultados detallados de una evaluación en específico. Mostrando el puntaje, la cantidad de pregutas correctas e incorrectas, así como los temas aprobados y no aprobados.</p>
            <p>Para las respuestas incorrectas, se presenta un análisis que explica el error e incluye el botón <span className='Help__Text--Highlight'>Ir al tema</span>, que permite reforzar conocimientos accediendo nuevamente a los instrumentos del tema (teoría, cuestionario, vídeo y desafío).</p>
        </>
    )
}

export { Results };